import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface UserFilterSelectProps {
  value: string | null;
  onChange: (next: string | null) => void;
  members: { user_id: string; display_name: string }[];
  currentUserId: string;
}

const ALL_VALUE = '__all__';
const ME_VALUE = '__me__';

export function UserFilterSelect({ value, onChange, members, currentUserId }: UserFilterSelectProps) {
  // value=null → "All workspace"; value === currentUserId → "Just me"; else specific member
  const selected = value === null ? ALL_VALUE : value === currentUserId ? ME_VALUE : value;

  function handleChange(next: string) {
    if (next === ALL_VALUE) onChange(null);
    else if (next === ME_VALUE) onChange(currentUserId);
    else onChange(next);
  }

  // Sort members alphabetically by display_name; exclude self (rendered as "Just me" separately)
  const otherMembers = members
    .filter((m) => m.user_id !== currentUserId)
    .sort((a, b) => a.display_name.localeCompare(b.display_name));

  return (
    <Select value={selected} onValueChange={handleChange}>
      <SelectTrigger className="w-48 h-9">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_VALUE}>All workspace</SelectItem>
        <SelectSeparator />
        <SelectItem value={ME_VALUE}>Just me</SelectItem>
        {otherMembers.length > 0 && <SelectSeparator />}
        {otherMembers.map((m) => (
          <SelectItem key={m.user_id} value={m.user_id}>
            {m.display_name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
